import { render, staticRenderFns } from "./Oncecard.vue?vue&type=template&id=5a000fec&"
import script from "./Oncecard.vue?vue&type=script&lang=js&"
export * from "./Oncecard.vue?vue&type=script&lang=js&"
import style0 from "./Oncecard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports